// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_44-0";